import PropTypes from "prop-types"

export const RedirectExternal = ({ to }) => {
    // eslint-disable-next-line no-undef
    window.location.replace(to)

    return null
}

RedirectExternal.propTypes = {
    to: PropTypes.string.isRequired,
}

RedirectExternal.defaultProps = {}

export default RedirectExternal
